//logoの表示
jQuery(window).on('load',function(){
    jQuery("#splash").delay(1800).fadeOut('slow');//ローディング画面を1.5秒（1500ms）待機してからフェードアウト
    jQuery("#splash_logo").delay(1600).fadeOut('slow');//ロゴを1.2秒（1200ms）待機してからフェードアウト
  });